import React from 'react';
import { PageNavigation, RenderOnlyFor } from '@ignitesales/neuro-application';
import DialogueProgressBar from "../../core-components/DialogueProgressBar";
import LoadingDataIcon from "../../core-components/LoadingDataIcon";
import { scrollToTop } from '../../index';
import StarterProgressBar from "./StarterProgressBar";

/**
 * Mobile navigation bar component displayed on survey pages
 */
const MobileNavigationBar = () => {
  return (
    <RenderOnlyFor forSurveyPage={true}>
      <div className="navigationBar mobile-nav-bar">
        <LoadingDataIcon />
        <div className="navigationBar__box">
          <DialogueProgressBar ProgressBarComponent={StarterProgressBar} />
        </div>
        <PageNavigation className="mobile-nav" onNextPageClicked={scrollToTop} onPreviousPageClicked={scrollToTop} />
      </div>
    </RenderOnlyFor>
  );
};

export default MobileNavigationBar;
